jQuery(document).ready(function() {
    // Check if component is added to the page
    if (jQuery('section.calendar').length) {

        let $ = jQuery;
        const $container = $(".js-calendar-wrapper");
        const $loadMoreBtn = $("#load-more-events");
        const $eventFilter = $(".event-filter");

        var $lastDay = null, $today, $category, $month, $year;

        $eventFilter.on("change", function() {
            $dataFor = $(this).data('for');
            $value = $(this).val();
            $container.attr('data-' + $dataFor, $value);
            if ($dataFor == 'year' && $container.attr('data-month') == '') {
                return;
            }
            $container.attr('data-page', '0');
            $container.empty();
            // $loadingWheel.show();
            loadResults(false);
        });

        $loadMoreBtn.on("click", function() {
            loadResults(true);
        });

        function loadResults(loadMore) {
            $page = parseInt($container.attr('data-page')) + 1;
            $today = $container.attr('data-today');
            $category = $container.attr('data-category');
            $month = $container.attr('data-month');
            $year = $container.attr('data-year');

            if (loadMore == true) {
                $startDate = $lastDay;
            } else {
                $startDate = $today;
                $loadMoreBtn.fadeOut();
            }

            var sendData = {
                action: 'events_ajax_handler',
                category: $category,
                today: $today,
                month: $month,
                year: $year,
                page: $page,
                startDate: $startDate,
                _nocache: new Date().getTime(), // Cache busting
                nonce: ajaxadminurl.nonce
            };

            $.ajax({
                url: ajaxadminurl.ajaxurl,
                type: 'GET',
                data: sendData,
                dataType: 'html',
                cache: false,
                timeout: 10000,
                beforeSend: function() {
                    // $loadMoreEntriesContainer.hide();
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    // $loadMoreEntriesContainer.remove();
                },
                success: function(data, textStatus, jqXHR) {
                    var htmlData = $.parseHTML(jqXHR.responseText);
                    $container.append(htmlData);
                    
                    // Update last day from the last .day-wrapper data attribute
                    var $lastWrapper = $container.find('.day-wrapper').last();
                    if ($lastWrapper.length) {
                        $lastDay = $lastWrapper.attr('data-date');
                    }
                    
                    if (data.trim() !== '<div class="nothing-found"><h4>No results found</h3></div>') {
                        $container.attr('data-page', $page)
                        $loadMoreBtn.fadeIn();
                    } else {
                        $loadMoreBtn.fadeOut();
                    }
                    AOS.init();
                },
                complete: function(data) {
                    loading = false; // Set loading to false to allow future AJAX requests
                }
            });
        }
    }
});
